module.exports = __webpack_public_path__ + "img/permission_denied.063088ae.png";